/*
  New Parent Message Form Controller
*/

import MessageFormController from './message-form-controller';
import { createCustomEvent } from '../../shared/helpers';

export default class extends MessageFormController {

  handleFormClosure(data) {
    const { html, url, id } = data;
    const messageDiv = this.getMessageDiv({ html, url, id });
    this.addNewMessage(messageDiv);
    this.enableNewMessageButton();
  }

  getMessageDiv({ html, url, id }) {
    const newMessage = document.createElement('div');
    newMessage.setAttribute('data-controller', 'message');
    newMessage.setAttribute('data-message-url', url);
    newMessage.setAttribute('data-message-id', id);
    newMessage.className = 'display-card messages--message-div with-shadow';
    newMessage.innerHTML = html;
    return newMessage;
  }

  addNewMessage(newMessage) {
    document.dispatchEvent(createCustomEvent("message:new-parent-create-success", this.messageFeed, { newMessage }))
    this.element.closest('.inline-msg-container').remove();
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/messages/new-parent-message-form-controller.js